<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'

import { AdWrapper } from '@toni/brand-ui'

import { queueAdEvent } from '../../advertisement/utils/queue-ad-event'

const props = withDefaults(
  defineProps<{
    slotName: string,
    float?: boolean,
    minWidth?: string,
    minHeight?: string
  }>(),
  {
    float: false,
    minWidth: undefined,
    minHeight: undefined
  }
)
const adSlotRef = ref<null | HTMLElement>(null)

onBeforeMount(() => {
  queueAdEvent(moltenBundle => {
    if (props.slotName) {
      moltenBundle.push(props.slotName)
    }
  })
})
</script>

<template>
  <div ref="adSlotRef">
    <AdWrapper :slot-name="props.slotName"
               :min-width="minWidth"
               :min-height="minHeight"
               :class="{
                 'sm:float-right sm:ml-6 lg:mr-24 lg:ml-10': float,
                 'sm:mx-auto': !float
               }">
      <slot />
    </AdWrapper>
  </div>
</template>
